<template>
  <div data-module="work-related-articles">
    <div class="module-layout">
      <div class="section-title">Related Work</div>
      <div class="content-container left"
        v-if="haveArticleLeft"
        :class="containerClasses"
      >
        <mouse-event-container>
          <router-link class="no-hover"
            :to="getRouterLink(articleContentLeft)"
          >
            <div class="title">{{articleContentLeft.headline}}</div>
          </router-link>
          <router-link
            :to="getRouterLink(articleContentLeft)"
          >
            {{articleContentLeft.linkText}}
          </router-link>
        </mouse-event-container>
      </div>
      <div class="content-container right"
        v-if="haveArticleRight"
        :class="containerClasses"
      >
        <mouse-event-container>
          <router-link class="no-hover"
            :to="getRouterLink(articleContentRight)"
          >
            <div class="title">{{articleContentRight.headline}}</div>
          </router-link>
          <router-link
            :to="getRouterLink(articleContentRight)"
          >
            {{articleContentRight.linkText}}
          </router-link>
        </mouse-event-container>
      </div>
    </div>
  </div>
</template>

<script>
/*
  Work section RelatedArticles module

  data record:
  {
    articles: [
      <work-article-slug>,
      <work-article-slug>,
    ]
  }
*/
// Components
import MouseEventContainer from '@/components/MouseEventContainer';
import workArticleIndex from '@/content/work-article-index';

import WorkMixin from './WorkMixin';

export default {

  name: 'work-related-articles',

  components: { MouseEventContainer },

  props: ['data'],

  mixins: [WorkMixin],

  computed: {

    articleSlugLeft() {
      const { articles } = this.data;
      return articles[0];
    },

    articleSlugRight() {
      const { articles } = this.data;
      return articles[1];
    },

    articleContentLeft() {
      const { articleSlugLeft: slug } = this;
      return this.getArticleData(slug);
    },

    articleContentRight() {
      const { articleSlugRight: slug } = this;
      return this.getArticleData(slug);
    },

    haveArticleLeft() {
      const { articleSlugLeft: slug, articleContentLeft: content } = this;
      return (slug !== undefined && content !== undefined);
    },

    haveArticleRight() {
      const { articleSlugRight: slug, articleContentRight: content } = this;
      return (slug !== undefined && content !== undefined);
    },

    deviceType() {
      let deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },

    containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      const { deviceType } = this;

      const classes = [deviceType];
      return classes.join(' ');
    },

  },

  methods: {

    getArticleData(slug) {
      const result = workArticleIndex.filter(item => (item.slug === slug));
      return result[0];
    },

    getRouterLink(data) {
      return {
        name: 'work-article',
        path: data.url,
        params: {
          slug: data.slug,
        },
      };
    },

  },

};
</script>


<style lang="scss" scoped>
@import '~@/styles/_mixins.scss';
@import '~@/styles/_grid.scss';
@import '~@/styles/_typography.scss';

$layout--percentage: $layout--max-content-width-ng / $layout--optimal-desktop * 100%;
$layout--inset: 26 * 1px;

[data-module="work-related-articles"] {
  width: 100%;

  // media query props
  margin-bottom: rem($layout--default-module-spacing-mobile);

  @include ngMq($nbp--tablet, up) {
    margin-bottom: rem($layout--default-module-spacing-tablet);
  }

  @include ngMq($nbp--desktop, up) {
    margin-bottom: rem($layout--default-module-spacing-desktop);
  }

  .module-layout {
    // media query props
    @include ngGrid('mobile');

    @include ngMq($nbp--tablet, up) {
      @include ngGrid('tablet');
    }

    @include ngMq($nbp--desktop, up) {
      @include ngGrid('desktop');
    }

    .section-title {
      grid-column: 1 / span 5;
      grid-row: 1;

      color: #333;

      // media query props
      @include sansserif($size: (18, 18, 0), $weight: 'light');

      @include ngMq($nbp--tablet, up) {
        @include sansserif($size: (18, 18, 0), $weight: 'light');
      }

      @include ngMq($nbp--desktop, up) {
        @include sansserif($size: (22, 22, 0), $weight: 'light');
      }
    }

    .content-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title {
        color: black;

        // media query props
        @include serif($size: (48, 63, 0), $weight: 'regular');
        margin-bottom: rem(10px);

        @include ngMq($nbp--tablet, up) {
          @include serif($size: (38, 63, 0), $weight: 'regular');
          margin-bottom: rem(10px);
        }
        @include ngMq($nbp--desktop, up) {
          @include serif($size: (48, 63, 0), $weight: 'regular');
          margin-bottom: rem(10px);
        }

      }

      .hover--active {
        a {
          text-decoration: underline;
        }
        a.no-hover {
          text-decoration: none;
        }
      }

    }

    .content-container.left.mobile {
      grid-row: 2;
      grid-column: 1 / span 6;
    }
    .content-container.right.mobile {
      grid-row: 3;
      grid-column: 1 / span 6;
    }
    .content-container.tablet.left,
    .content-container.desktop.left {
      grid-row: 2;
      grid-column: 1 / span 6;
    }
    .content-container.tablet.right,
    .content-container.desktop.right {
      grid-row: 2;
      grid-column: 7 / span 6;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/modules/work/RelatedArticles.vue